import {useRouteQuery} from '@github-ui/react-core/future/use-route-query'
import {useRouteQueryKey} from '@github-ui/react-core/future/use-route-query-key'
import {useInvalidateOnAliveUpdate} from '@github-ui/use-invalidate-on-alive-update'
import {pullRequestsOverviewRoute} from '../../../routes/overview-route'

export const useAssigneesQuery = () => useRouteQuery(pullRequestsOverviewRoute, 'assignees')

export const useAssigneesQueryKey = () => useRouteQueryKey(pullRequestsOverviewRoute, 'assignees')

export const useReviewRequestsQuery = () => useRouteQuery(pullRequestsOverviewRoute, 'review_requests')

/** Reads the review requests query key without subscribing to the query itself. */
export const useReviewRequestsQueryKey = () => useRouteQueryKey(pullRequestsOverviewRoute, 'review_requests')

export const useDevelopmentQuery = () => useRouteQuery(pullRequestsOverviewRoute, 'development')

/** Reads the development query key without subscribing to the query itself. */
export const useDevelopmentQueryKey = () => useRouteQueryKey(pullRequestsOverviewRoute, 'development')

export const useLabelsQuery = () => useRouteQuery(pullRequestsOverviewRoute, 'labels')

export const useLabelsQueryKey = () => useRouteQueryKey(pullRequestsOverviewRoute, 'labels')

export const useParticipantsQuery = () => useRouteQuery(pullRequestsOverviewRoute, 'participants')

/** Automatically observes for live updates. */
export const useDeploymentsQuery = () => {
  const query = useRouteQuery(pullRequestsOverviewRoute, 'deployments')

  const aliveChannel = query.data?.aliveChannel ?? ''
  useInvalidateOnAliveUpdate(aliveChannel, query.queryKey)

  return query
}
